/* SOYIA — interactions for the soyia-* sections.
   - Header: mobile drawer (open / close / Escape / click outside).
   - Videos: poster + round play button, tap to play / pause, paused again off screen.
   - Carousel: one card at a time, prev / next arrows, dots.
   - Buy box: gallery thumbnails; offers set the cart quantity and the button total;
     product options pick the variant sent to the cart; delivery dates in business days (es-MX);
     mobile sticky bar visible once the main button has scrolled away. */
(function () {
  if (window.SOYIA_READY) return;
  window.SOYIA_READY = true;
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- header drawer ---------- */
  function initHeader(h) {
    var drawer = h.querySelector('[data-sy-drawer]');
    var open = h.querySelector('[data-sy-open]');
    if (!drawer || !open) return;
    function set(on) {
      drawer.hidden = !on; open.setAttribute('aria-expanded', String(on));
      document.documentElement.style.overflow = on ? 'hidden' : '';
      if (on) { var c = drawer.querySelector('[data-sy-close]'); if (c) c.focus(); } else { open.focus(); }
    }
    open.addEventListener('click', function () { set(true); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-sy-close]')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) set(false); });
  }

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var value = (cents / 100);
    var fixed2 = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fixed0 = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, fixed0)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, fixed2);
  }

  /* ---------- delivery dates (business days, Mon–Fri) ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime()); var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d;
  }
  function initEta(el) {
    var min = parseInt(el.dataset.min, 10) || 5, max = parseInt(el.dataset.max, 10) || 9;
    var fmt = new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric', month: 'short' });
    var now = new Date();
    var from = fmt.format(addBusinessDays(now, Math.min(min, max)));
    var to = fmt.format(addBusinessDays(now, Math.max(min, max)));
    var out = el.querySelector('[data-sy-eta-out]');
    var text = el.dataset.text || '';
    if (out) out.innerHTML = text.replace('[from]', '<strong>' + from + '</strong>').replace('[to]', '<strong>' + to + '</strong>');
  }

  /* ---------- buy box ---------- */
  function initBuyBox(root) {
    if (root.dataset.syReady) return; root.dataset.syReady = '1';
    var fmt = root.dataset.moneyFormat;
    var form = root.querySelector('#sy-product-form');
    var idInput = root.querySelector('[data-sy-variant]');
    var qtyInput = root.querySelector('[data-sy-qty]');
    var totalEl = root.querySelector('[data-sy-total]');
    var atc = root.querySelector('[data-sy-atc]');
    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-sy-variants]') || {}).textContent || '[]'); } catch (e) { variants = []; }

    // gallery (v2): the stage is a carousel (initCarousel); thumbnails jump to a slide and follow the scroll
    var track = root.querySelector('.sy-bb__track'), thumbs = $all('[data-sy-thumb]', root);
    if (track && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { track.scrollTo({ left: Number(t.dataset.syThumb) * track.clientWidth, behavior: 'smooth' }); });
      });
      var lastThumb = -1;
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i === lastThumb) return; lastThumb = i;
        thumbs.forEach(function (x, n) { x.setAttribute('aria-current', String(n === i)); });
        var t = thumbs[i]; if (t && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }, { passive: true });
    }

    // Kaching: once its widget renders a deal, it owns offers + quantity; the native offers stay as fallback otherwise
    var kaching = root.querySelector('[data-sy-kaching]');
    if (kaching) {
      var native = root.querySelector('.sy-bb__offers');
      var takeOver = function () {
        if (!kaching.childElementCount && !(kaching.shadowRoot && kaching.shadowRoot.childElementCount)) return false;
        if (native) native.hidden = true;
        if (qtyInput) qtyInput.disabled = true;
        return true;
      };
      if (!takeOver() && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { if (takeOver()) mo.disconnect(); });
        mo.observe(kaching, { childList: true, subtree: true });
      }
    }

    function currentVariant() {
      if (!variants.length) return null;
      var picks = $all('[data-sy-opt]:checked', root).map(function (r) { return { i: Number(r.dataset.syOpt), v: r.value }; });
      if (!picks.length) return variants.find(function (v) { return String(v.id) === String(idInput.value); }) || variants[0];
      return variants.find(function (v) { return picks.every(function (p) { return v.options[p.i] === p.v; }); }) || null;
    }
    function currentOffer() { return root.querySelector('[data-sy-offer]:checked'); }

    function update() {
      var v = currentVariant();
      var offer = currentOffer();
      var qty = offer ? (parseInt(offer.dataset.qty, 10) || 1) : 1;
      var paid = offer ? (parseInt(offer.dataset.paid, 10) || qty) : qty; // units charged (lower than qty only with a real Buy X Get Y discount)
      if (qtyInput) qtyInput.value = qty;
      if (v && idInput) idInput.value = v.id;
      var available = !!(v && v.available);
      if (atc) atc.disabled = !available;
      if (totalEl) {
        var priceText = offer ? offer.dataset.priceText : '';
        if (priceText && priceText.indexOf('[') === -1) totalEl.textContent = priceText;
        else if (v && v.price > 0) totalEl.textContent = formatMoney(v.price * paid, fmt);
        else totalEl.textContent = priceText || '';
      }
      // offer prices computed from the variant price when the offer has no fixed text
      $all('[data-sy-offer]', root).forEach(function (o) {
        var holder = o.closest('.sy-bb__offer'); if (!holder) return;
        var out = holder.querySelector('[data-sy-oprice]');
        var oq = parseInt(o.dataset.qty, 10) || 1, op = parseInt(o.dataset.paid, 10) || oq;
        if (out && !o.dataset.priceText && v) out.textContent = formatMoney(v.price * op, fmt);
        var strike = holder.querySelector('[data-sy-ostrike]');
        if (strike && v) strike.textContent = formatMoney(v.price * oq, fmt);
      });
      // sticky bar mirrors the selected offer
      var sName = root.querySelector('[data-sy-sticky-name]'), sSub = root.querySelector('[data-sy-sticky-sub]');
      if (offer && sName) {
        var card = offer.closest('.sy-bb__offer');
        var t = card && card.querySelector('.sy-bb__oname'), st2 = card && card.querySelector('.sy-bb__osub');
        if (t) sName.textContent = t.textContent;
        if (sSub && v) sSub.textContent = (st2 ? st2.textContent.split(' · ')[0] + ' · ' : '') + formatMoney(v.price * paid, fmt);
      }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-sy-offer], [data-sy-opt]')) update(); });
    update();

    $all('[data-sy-eta]', root).forEach(initEta);

    // sticky bar
    var bar = root.querySelector('[data-sy-sticky]');
    if (bar && atc && 'IntersectionObserver' in window) {
      var btn = bar.querySelector('button');
      // a sticky bar that names an offer ("Compra 3 y llévate 3 gratis") selects that offer before adding to cart
      if (btn && btn.dataset.syStickyOffer) btn.addEventListener('click', function () {
        var o = $all('[data-sy-offer]', root)[Number(btn.dataset.syStickyOffer)];
        if (o && !o.checked) { o.checked = true; update(); }
      });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var on = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on));
          if (btn) btn.tabIndex = on ? 0 : -1;
        });
      }).observe(atc);
    }
  }

  /* ---------- carousel: one card at a time, 44 px side arrows ---------- */
  function initCarousel(root) {
    if (root.dataset.syReady) return; root.dataset.syReady = '1';
    var track = root.querySelector('[data-sy-track]');
    var prev = root.querySelector('[data-sy-prev]'), next = root.querySelector('[data-sy-next]');
    var dots = $all('[data-sy-dot]', root), count = root.querySelector('[data-sy-count]');
    if (!track) return;
    function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; }
    function index() { return Math.round(track.scrollLeft / Math.max(step(), 1)); }
    function sync() {
      var i = index(), max = track.scrollWidth - track.clientWidth;
      // arrows only when there is something to scroll in that direction
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = max <= 2 || track.scrollLeft >= max - 2;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); });
      if (count) count.textContent = String(i + 1);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { track.scrollTo({ left: n * step(), behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  /* ---------- videos: play / pause on tap (no autoplay), pause when off screen ---------- */
  var videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (!en.isIntersecting && !en.target.paused) en.target.pause(); });
  }, { threshold: 0.1 }) : null;
  function initVideos() {
    $all('[data-sy-vid]').forEach(function (box) {
      if (box.dataset.syReady) return; box.dataset.syReady = '1';
      var v = box.querySelector('video'), btn = box.querySelector('[data-sy-vid-play]');
      if (!v) return;
      v.muted = true; v.removeAttribute('autoplay');
      function sync() { box.classList.toggle('is-playing', !v.paused); if (btn) btn.setAttribute('aria-label', v.paused ? 'Reproducir video' : 'Pausar video'); }
      function toggle(e) { if (e) { e.preventDefault(); e.stopPropagation(); } if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); } }
      if (btn) btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
      if (videoObserver) videoObserver.observe(v);
    });
  }

  /* ---------- comparison tabs: Soyia vs the competitor picked ---------- */
  function initCompareTabs(tabs) {
    if (tabs.dataset.syReady) return; tabs.dataset.syReady = '1';
    var table = tabs.parentNode.querySelector('.sy-cmp--tabs');
    $all('[data-sy-cmp-tab]', tabs).forEach(function (b) {
      b.addEventListener('click', function () {
        if (table) table.dataset.show = b.dataset.syCmpTab;
        $all('[data-sy-cmp-tab]', tabs).forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
      });
    });
  }

  /* ---------- pop-ups (native <dialog>): open buttons, round close, click outside or Escape closes ---------- */
  if (!window.SOYIA_DIALOGS) {
    window.SOYIA_DIALOGS = true;
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-sy-dialog-open]');
      if (open) {
        var d = document.getElementById(open.dataset.syDialogOpen);
        if (d && d.showModal) { d.showModal(); document.documentElement.style.overflow = 'hidden'; }
        return;
      }
      var dlg = e.target.closest('dialog.sy-dlg');
      if (e.target.closest('[data-sy-dialog-close]') || (e.target.tagName === 'DIALOG' && e.target.classList.contains('sy-dlg'))) {
        (dlg || e.target).close();
      }
    });
    document.addEventListener('close', function (e) {
      if (e.target.classList && e.target.classList.contains('sy-dlg')) document.documentElement.style.overflow = '';
    }, true);
  }

  /* ---------- "Ver todas": smooth scroll to the Judge.me widget lower on the page ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sy-scroll-to]'); if (!a) return;
    var t = document.querySelector(a.dataset.syScrollTo); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- free-shipping timer: one window per visitor, start time kept in localStorage ---------- */
  function initTimer(el) {
    if (el.dataset.syReady) return; el.dataset.syReady = '1';
    var mins = parseInt(el.dataset.minutes, 10) || 15, cool = (parseInt(el.dataset.cooldown, 10) || 24) * 3600e3;
    var text = el.dataset.text || '', done = el.dataset.done || '', KEY = 'soyia_ship_timer_start', start = Date.now();
    try {
      var saved = parseInt(localStorage.getItem(KEY), 10);
      if (saved && Date.now() - saved < cool) start = saved; else localStorage.setItem(KEY, String(start));
    } catch (e) {}
    var end = start + mins * 60e3;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (left <= 0) { el.textContent = done; el.classList.add('is-done'); return; }
      el.textContent = text.replace('{mm:ss}', pad(Math.floor(left / 60)) + ':' + pad(left % 60));
      setTimeout(tick, 1000);
    }
    tick();
  }

  function init() {
    initVideos();
    $all('[data-sy-timer]').forEach(initTimer);
    $all('[data-sy-cmp-tabs]').forEach(initCompareTabs);
    $all('[data-sy-carousel]').forEach(initCarousel);
    $all('[data-sy-header]').forEach(initHeader);
    $all('[data-sy-bb]').forEach(initBuyBox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
